/* eslint-disable no-prototype-builtins */
/* eslint-disable react/no-array-index-key */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
import React, {
  useEffect, useState, Fragment,
} from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import { Table, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleQuestion,
} from '@fortawesome/free-solid-svg-icons';
import RfqActions from '@Actions/purchase/rfq/rfqActions';
import Attachment from '@Components/Common/Attachment';
import './style.scss';

const PastNegotiations = ({
  user, rfqParticipant, getRfqParticipantNegotiations, getRfqParticipantNegotiationsLoading, participantNegotiations, MONEY, getRfqParticipantNegotiationsSuccess,
}) => {
  const [data, setData] = useState([]);
  const [columnKeys, setColumnKeys] = useState([]);

  useEffect(() => {
    getRfqParticipantNegotiations(rfqParticipant?.rfq_participant_id, (pastNego) => {
      setData(pastNego);
      setColumnKeys(Object.keys(pastNego?.[0]))?.filter((i) => i !== 'Other Charges');
    });

    return () => {
      getRfqParticipantNegotiationsSuccess(null);
      setData([]);
      setColumnKeys([]);
    };
  }, []);

  const renderOtherCharges = (otherCharges) => otherCharges.map((otherCharge, i) => (
    <div key={i} style={{ display: 'flex', justifyContent: 'center' }}>
      {`${otherCharge?.charge_name} - ${otherCharge?.value}`}
    </div>
  ));

  const renderLineQuesAns = (rfqAnswers, remarks) => (
    <div className="past-negotiation__qa-line-wrapper">
      {rfqAnswers?.map((qa, i) => (
        <div className="past-negotiation__line-ques" key={i}>
          <FontAwesomeIcon icon={faCircleQuestion} style={{ marginTop: '3px' }} />
          &nbsp;
          <div>
            <div className="past-negotiation__line-ques_q">{qa?.question}</div>
            <div className="past-negotiation__line-ques_a">{qa?.answer}</div>
          </div>
        </div>
      ))}
      {remarks ? <div className="past-negotiation__line-ques">
        <FontAwesomeIcon icon={faCircleQuestion} style={{marginTop: '3px'}}/>
        &nbsp;
        <div>
          <div className="past-negotiation__line-ques_q">Remarks</div>
          <div className="past-negotiation__line-ques_a">{remarks}</div>
        </div>
      </div> : ''}
    </div>
  );

  const renderQuesAns = (rfqAnswers) => (rfqAnswers?.map((qa, i) => (
    <div className="past-negotiation__qa-wrapper" key={i}>
      <div className="past-negotiation__qa-question">{qa?.question}</div>
      <div className="past-negotiation__qa-answer">{qa?.answer}</div>
    </div>
  )));

  const getVendorOfferRecordData = (record, key) => {
    if (record[key]?.hasOwnProperty('is_product_participant_negotiation')) {
      return <div style={{ display: 'flex', justifyContent: 'center', width: '120px' }}>{record[key]?.price ? MONEY(record[key].price) : '-'}</div>;
    }

    if (record[key]?.hasOwnProperty('is_total_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{MONEY(record[key]?.negotiation_total || 0)}</div>;
    }

    if (record[key]?.hasOwnProperty('is_taxes_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{MONEY(record[key]?.negotiation_tax_total || 0)}</div>;
    }

    if (record[key]?.hasOwnProperty('is_other_charges_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{record[key]?.other_charges?.length ? renderOtherCharges(record[key]?.other_charges) : '-'}</div>;
    }

    if (record[key]?.hasOwnProperty('is_grand_total_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{MONEY(record[key]?.negotiation_grand_total)}</div>;
    }

    return null;
  };

  const getCounterOfferRecordData = (record, key) => {
    if (record[key]?.hasOwnProperty('product_sku_name')) {
      return (
        <div style={{ width: '120px' }}>
          <Link to={`/inventory/product/view/${record[key]?.product_sku_info?.product_sku_id}`} target="_blank">
            {`#${record[key]?.product_sku_info?.internal_sku_code}`}
          </Link>
          <H3Text text={`${record[key]?.product_sku_info?.ref_product_code ? `${record[key]?.product_sku_info?.ref_product_code} - ` : ''}${record[key]?.product_sku_info?.product_sku_name}`?.trim()} className="" />
        </div>
      );
    }

    if (record[key]?.hasOwnProperty('is_product_participant_negotiation')) {
      return <div style={{ display: 'flex', justifyContent: 'center', width: '120px' }}>{Number(record?.[key]?.counter_price) > 0 ? MONEY(record[key]?.counter_price) : '-'}</div>;
    }

    if (record[key]?.hasOwnProperty('is_total_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{MONEY(record[key]?.negotiation_counter_total || 0)}</div>;
    }

    if (record[key]?.hasOwnProperty('is_taxes_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{Number(record[key]?.negotiation_tax_counter_total) > 0 ? MONEY(record[key]?.negotiation_tax_counter_total) : '-'}</div>;
    }

    if (record[key]?.hasOwnProperty('is_other_charges_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{record[key]?.other_charges?.length ? renderOtherCharges(record[key]?.other_charges) : '-'}</div>;
    }

    if (record[key]?.hasOwnProperty('is_grand_total_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{Number(record[key]?.negotiation_grand_counter_total) > 0 ? MONEY(record[key]?.negotiation_grand_counter_total) : '-'}</div>;
    }

    return null;
  };

  const getConfirmedOfferRecordData = (record, key) => {
    if (record[key]?.hasOwnProperty('product_sku_name')) {
      return (
        <div style={{ width: '200px' }}>
          <Link to={`/inventory/product/view/${record[key]?.product_sku_info?.product_sku_id}`} target="_blank">
            {`#${record[key]?.product_sku_info?.internal_sku_code}`}
          </Link>
          <H3Text text={`${record[key]?.product_sku_info?.ref_product_code ? `${record[key]?.product_sku_info?.ref_product_code} - ` : '' }${record[key]?.product_sku_info?.product_sku_name}`?.trim()} className="" />
        </div>
      );
    }

    if (record[key]?.hasOwnProperty('is_product_participant_negotiation')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{MONEY(record[key]?.counter_price || record[key]?.price || 0)}</div>;
    }

    if (record[key]?.hasOwnProperty('is_total_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{MONEY(record[key]?.negotiation_counter_total || record[key]?.negotiation_total)}</div>;
    }

    if (record[key]?.hasOwnProperty('is_taxes_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{MONEY(record[key]?.negotiation_tax_counter_total || record[key]?.negotiation_tax_total)}</div>;
    }

    if (record[key]?.hasOwnProperty('is_other_charges_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{record[key]?.other_charges?.length ? renderOtherCharges(record[key]?.other_charges) : '-'}</div>;
    }

    if (record[key]?.hasOwnProperty('is_grand_total_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{MONEY(record[key]?.negotiation_grand_counter_total || record[key]?.negotiation_grand_total)}</div>;
    }

    return null;
  };

  const getRecordData = (record, key) => {
    if (!record[key] || typeof record[key] !== 'object') {
      return (
        <Fragment>
          <div style={{
            fontSize: '13px',
            fontWeight: '500',
          }}
          >
            {record[key] !== 'Negotiation' ? record[key] : ' '}
          </div>
        </Fragment>
      );
    }

    if (record[key].hasOwnProperty('product_sku_name')) {
      const productName = `${record[key]?.product_sku_info?.ref_product_code ? `${record[key]?.product_sku_info?.ref_product_code} - ` : ''}${record[key]?.product_sku_info?.product_sku_name}`?.trim();
      return (
        <Fragment>
          <div style={{ width: '250px' }}>
            <Tooltip title={productName}>
              <Link to={`/inventory/product/view/${record[key]?.product_sku_info?.product_sku_id}`} target="_blank">
                {`#${record[key]?.product_sku_info?.internal_sku_code}`}
              </Link>
              <H3Text text={productName} className="rfq-comparator__prod-name" />
            </Tooltip>
            <div>{renderLineQuesAns(record[key]?.rfq_answers, record[key]?.remarks)}</div>
          </div>
        </Fragment>
      );
    }

    return null;
  };

  const getColumns = () => {
    const columns = [];

    columnKeys.forEach((key) => {
      const obj = {
        title: (
          <div className="participant-name__wrapper">
            <Tooltip title={data?.[0][key]}>
              <H3Text text={data?.[0][key]} className="participant-name" />
            </Tooltip>
          </div>
        ),
        fixed: 'left',
        width: '200px',
        render: (record) => (
          <Fragment>
            {getRecordData(record, key)}
          </Fragment>
        ),
      };

      columns.push(obj);
      if (data?.[0][key] !== '') {
        if (data?.[1][key]?.uom_info) {
          obj.width = '80px';
          obj.title = '';
          obj.render = (record) => (
            <div className="participant-item-tax" style={{ width: '80px' }}>
              <div>
                {record?.[key]?.quantity ? `${record?.[key]?.quantity} ${record?.[key]?.uom_info?.uqc?.toProperCase()}` : ''}
              </div>
              {record?.column_name?.tax_info?.tax_value >= 0 ? <H3Text text={`+ tax @${record?.column_name?.tax_info?.tax_value}%`} className="danger-subtext" /> : ''}
            </div>
          );
        } else if (data?.[1][key]?.rfq_line_status === 'ACCEPTED') {
          obj.fixed = null;
          obj.render = (record) => (
            <Fragment>
              <div className={record?.column_name === 'Negotiation' ? 'rfq-comparator__actions' : ''}>
                {getConfirmedOfferRecordData(record, key)}
              </div>
            </Fragment>
          );
        } else {
          obj.children = [
            {
              title: <div style={{ display: 'flex', justifyContent: 'center' }}>Vendor Offer</div>,
              width: '120px',
              render: (record) => (
                <div className={record?.column_name === 'Negotiation' ? 'rfq-comparator__actions' : ''}>
                  {getVendorOfferRecordData(record, key)}
                </div>
              ),
            },
            {
              title: <div style={{ display: 'flex', justifyContent: 'center' }}>Counter Offer</div>,
              width: '120px',
              render: (record) => (
                <div className={record?.column_name === 'Negotiation' ? 'rfq-comparator__actions' : ''}>
                  {getCounterOfferRecordData(record, key)}
                </div>
              ),
            },
          ];
        }
      } else {
        obj.render = (record) => (
          <Fragment>
            {getRecordData(record, key)}
          </Fragment>
        );
      }
    });

    return columns;
  };

  const getDataSource = () => {
    const copyData = JSON.parse(JSON.stringify(participantNegotiations?.data?.filter((i) => !['Negotiation', 'Other Charges'].includes(i?.column_name)) || []));

    return copyData.slice(1) || [];
  };

  return (
    <Fragment>
      <div className="past-negotiation__wrapper">
        <div className="past-negotiation__header-wrapper">
          {data[7] && (
            <div style={{ width: '50%' }}>
              {renderQuesAns(data[7]['Negotiation 1']?.rfq_answers)}
            </div>
          )}
          {
              rfqParticipant?.remarks && (
              <div className="past-negotiation__qa-wrapper">
                <div className="past-negotiation__qa-question">Remarks</div>
                <div className="past-negotiation__qa-answer">{rfqParticipant?.remarks}</div>
              </div>
            )
          }
        </div>
        <div className="past-negotiation__body-wrapper">
          <Table
            bordered
            loading={getRfqParticipantNegotiationsLoading}
            showHeader
            size="small"
            scroll={{ x: true }}
            columns={getColumns()}
            dataSource={getDataSource()}
            pagination={false}
          />
        </div>

        <div className="past-negotiation__footer-wrapper">
          {(rfqParticipant?.attachments?.length && !getRfqParticipantNegotiationsLoading) ? (
            <Attachment
              fileList={rfqParticipant?.attachments}
              disableCase
              label="Attachments"
              updateEnable={Helpers.getPermission(Helpers.permissionEntities.REQUEST_FOR_QUOTATION, Helpers.permissionTypes.UPDATE, user)}
            />
          ) : ''}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, RfqReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  participantNegotiations: RfqReducers.participantNegotiations,
  getRfqParticipantNegotiationsLoading: RfqReducers.getRfqParticipantNegotiationsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getRfqParticipantNegotiations: (rfqParticipantId, callback) => dispatch(RfqActions.getRfqParticipantNegotiations(rfqParticipantId, callback)),
  getRfqParticipantNegotiationsSuccess: (participantNegotiations) => dispatch(RfqActions.getRfqParticipantNegotiationsSuccess(participantNegotiations)),
});

PastNegotiations.propTypes = {
  user: PropTypes.any,
  match: PropTypes.any,
  MONEY: PropTypes.any,
  history: PropTypes.any,
  getRfqParticipantNegotiationsSuccess: PropTypes.any,
  participantNegotiations: PropTypes.any,
  rfqParticipant: PropTypes.func,
  getRfqParticipantNegotiationsLoading: PropTypes.bool,
  getRfqParticipantNegotiations: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PastNegotiations));
